import React, { useState, useEffect, useReducer } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import moment from 'moment';
import {
    Form,
    Row,
    Col,
    Button,
    Input,
    Select,
    Table,
    Popconfirm,
    DatePicker,
    Modal,
    message
} from 'antd';
import { getBusiListExportRequest, exportListRequest } from '../../api/api'
import { useCallbackState } from '../../util/useCallbackState'
import { downFileWithBlob } from '../../util/tools'
const { Option } = Select;
const dateFormat = 'YYYY-MM-DD';
const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
};
const { RangePicker } = DatePicker;
const ExportList = (data) => {
    const [form] = Form.useForm();
    const { state } = useLocation();
    const [list, setList] = useState([])
    const [currentPage, setCurrentPage] = useCallbackState(1)
    const [pageNum, setPageNum] = useCallbackState(10)
    const [total, setTotal] = useState()
    const [mySwitch, setMySwitch] = useState(state && state.tag == 1 ? true : localStorage.state == "1" ? true : false)
    const superMerchantCode = localStorage.appid;
    const [busiList, setBusiList] = useState([])
    const { search } = useLocation()
    const navigate = useNavigate()
    const forceUpdate = useReducer((bool) => !bool)[1]
    useEffect(() => {
            getBusiListExport()
            console.log(data);
            getExportList()

    }, [currentPage, pageNum])
    const columns = [
        {
            title: '报表归属',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: '时间区间',
            dataIndex: 'dateZone',
            key: 'dateZone',
        },

        {
            title: '申请时间',
            dataIndex: 'exportTime',
            key: 'exportTime',
            width: 250,
        },
        {
            title: '任务状态',
            dataIndex: 'statusName',
            key: 'statusName',
        },
        {
            title: '操作人',
            dataIndex: 'operatorName',
            key: 'operatorName',
        },
        {
            title: '操作',
            key: 'operation',
            fixed: 'right',
            width: 150,
            align: 'right',
            render: (text, row) => (
                <>
                    {
                        row.statusName == '成功' ?
                            <span style={{ color: '#165BD4', cursor: 'pointer' }} onClick={() => {
                                window.open(row.downloadUrl)
                                // navigate('/ws/statementList/statementListdetail', { replace: false, state: row })
                            }}>下载</span> : null
                    }
                </>
            ),

        },
    ];



    const getExportList = (values) => {
        let params = {
            ...values,
            currentPage,
            pageSize: pageNum,
            superMerchantCode: localStorage.appid,
            merchantCode: localStorage.merchantCode,
            operatorId: localStorage.operatorId
        };
        (async _ => {
            //return await getCurrentUserPermissionListRequest(params);
            return await exportListRequest(params);
        })().then(res => {
            console.log(res);
            if (res.code == 0) {
                setList(res.data.lists)
                setTotal(res.data.totalCount)
            } else {
                message.error(res.msg)
            }
        });
    }

    const getBusiListExport = () => {
        (async _ => {
            //return await getCurrentUserPermissionListRequest(params);
            return await getBusiListExportRequest();
        })().then(res => {
            console.log(res);
            if (res.code == 0) {
                setBusiList(res.data)
            } else {
                message.error(res.msg)
            }
        });
    }
    const onChangPage = (currentPage, pageNum) => {
        // setInit(false)
        setCurrentPage(currentPage, () => {
        })
    }
    const onChangPageNum = (currentPage, pageNum) => {
        // setInit(false)
        setPageNum((currentPage, pageNum), () => {
        })
    }
    const onFinish = (values) => {
        getExportList(values)
    };



    return (
        <div style={{ background: '#ffffff', paddingTop: 1, marginTop: 16 }}>
            <Form
                form={form}
                {...layout}
                name="advanced_search"
                className="ant-advanced-search-form"
                onFinish={onFinish}
                style={{ background: '#F7F8FA', margin: 16, padding: 16, paddingBottom: 0 }}
                initialValues={{

                }}
            >
                <Row style={{ marginBottom: '-1vh' }}>
                    <Col span={6} >
                        <Form.Item
                            name="type"
                            label="报表归属"
                        >
                            <Select placeholder="请选择"
                                style={{ width: 180 }}
                            >
                                {
                                    busiList.length > 0 ? busiList.map((v, index) => {
                                        return <Option rowKey={index} key={v.busiType} value={v.busiType}>{v.busiTypeName}</Option>
                                    })
                                        : null
                                }

                            </Select>

                        </Form.Item>
                    </Col>
                    <Col span={6}>
                        <Form.Item
                            name="status"
                            label="任务状态"
                        >

                            <Select placeholder="请选择"
                                style={{ width: 180 }}
                            >
                                <Option key={0} value={0}>未处理</Option>
                                <Option key={1} value={1}>处理中</Option>
                                <Option key={2} value={2}>成功</Option>
                                <Option key={3} value={3}>失败</Option>
                                <Option key={4} value={4}>清除</Option>

                            </Select>
                        </Form.Item>
                    </Col>

                </Row>

                <Row style={{ marginBottom: '-1vh' }}>
                    <Col span={6}>
                        <Form.Item
                            wrapperCol={{
                                offset: 6,
                                span: 16,
                            }}
                        >
                            <Button type="primary" htmlType="submit">
                                筛选
                            </Button>
                            <Button type="link" onClick={() => {
                                form.resetFields();
                            }} >
                                重置筛选条件
                            </Button>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
            <Table
                locale={{
                    emptyText: "没有更多数据了"
                }}
                rowKey='id'
                style={{ marginTop: 16, margin: '0 16px' }}
                columns={columns}
                dataSource={list}
                scroll={{
                    x: 1600,
                }}
                pagination={{
                    total,
                    showSizeChanger: true,
                    current: currentPage,
                    pageSize: pageNum,
                    // position: ["bottomCenter"],
                    showTotal: (total, range) => `${range[0]}-${range[1]} 共${total} 条`,
                    onChange: (k, v) => onChangPage(k, v),
                    onShowSizeChange: (k, v) => onChangPageNum(k, v),
                }}
            />

        </div >
    )
}
export default ExportList;